class beuszoControl {
    init() {

        //if (document.cookie.indexOf("beuszoblokk-closed") == -1)
        //{
        if (window.newsletterPopupActive || sessionStorage.getItem('newsletter-popup-active')) {
            return;
        }

        $('.scroll-top').css('bottom', '240px');
        setTimeout(function () {
            if (window.newsletterPopupActive || sessionStorage.getItem('newsletter-popup-active')) {
                return;
            }
            $('.beuszo-uzenetek-doboz-kont').addClass('bring-up');
        }, 3000);
        // } else {
        //     $('.beuszo-uzenetek-doboz-kont').remove();
        // }

    }

    closeme() {

        $('.scroll-top').css('bottom', '20px');
        $('.beuszo-uzenetek-doboz-kont').removeClass('bring-up').addClass('bring-down');

        // var szunet = new Date(new Date().getTime()+(3600*24*1*1000));
        // document.cookie = "beuszoblokk-closed=1; expires=" + szunet.toGMTString();

        return false;
    }

}


class sargaCsikControl {

    openRegdobozok(el) {
        popupMessageSystem.showWin('');
        $('.pms-message').empty();



        $.get('/index.php/hirlevel/dialogs/feliratkozasdialog', { r: new Date().getTime(), gomburl: $(el).data('belepesgomb') }, function (res) {
            if (res != '') {
                $('.pms-message').html(res)

                $('.pms-main-win').css({
                    'width': $('.container:first').width() + 'px',
                    'left': 'calc(50% - (' + $('.container:first').width() + 'px / 2))',
                })



                var regDobozokItems = $('.lenyilo-reg-area .regisztracios-dobozok').clone().removeClass('hide');
                $('.pms-message .regdobozok-kont').append(regDobozokItems)

                var sargacsikSzoveg = $('.hirlevel-sargacsik-kont .szoveg').html();
                $('.pms-message .topmessage-kont').append(sargacsikSzoveg)


            }
        }, 'html')


        return false;
    }
}


class popupSzettLista {

    constructor() {
        this.init();
    }

    init() {
        if ($('.item.kezdoszett a.openlist').length > 0) {
            $('.item.kezdoszett a.openlist').each((i, el) => {
                $(el).on("click", (e) => {
                    e.preventDefault();
                    this.openMessage(e.target);
                })
            });
        }
    }

    openMessage(el) {
        popupMessageSystem.showWin('', 'szett-lista-win');
        $('.pms-message').empty();
        $('<div>').addClass('wait-datas').appendTo($('.pms-message'));

        $.get('/index.php/szettek/pupuplista', { szett_id: $(el).data('szett_id'), r: new Date().getTime() }, function (res) {
            if (res != '') {
                $('.pms-message').html(res)
            }
        }, 'html')

    }
}


class termekAdatlapVideo {


    init() {
        $('.main-content.ujadatlap .product-details .image-and-texts-kont .imgkont.video').each((i, vide) => {
            $(vide).on('click', (e) => {
                e.preventDefault();
                var vid = $(e.target);
                var tnev = "";
                if ($('.h1.oldalcim').length > 0) {
                    tnev = $('.h1.oldalcim').text().trim();
                }
                this.showPopUp(
                    vid,
                    tnev
                );
            });
        });
    }

    showPopUp(vid, termek_nev) {
        $('.pms-overlay, .termekadatlap-video-win').remove();

        var msgwin = $('<div>').addClass('termekadatlap-video-win');

        $('<div>').addClass('pms-overlay').on("click", function (e) { e.preventDefault(); $('.pms-overlay, .termekadatlap-video-win').remove(); }).appendTo($('body'));
        $('<a>').addClass('closeme').attr("href", "").on("click", function (e) { e.preventDefault(); $('.pms-overlay, .termekadatlap-video-win').remove(); }).appendTo(msgwin);

        var pVideo = $('<video>').attr('controls', '1');
        pVideo.attr('controlslist', 'nodownload');
        pVideo.attr('autoplay', '1');
        var pSource = $('<source>', pVideo).attr('type', 'video/mp4');

        if ($(vid).find('source').length == 0) {
            vid = $(vid).parents('.imgkont.video').find('video');
        }
        pSource.attr('src', $(vid).find('source').get(0).src);
        pSource.appendTo(pVideo);


        if (termek_nev != '') {
            var termnev_kont = $('<div>').addClass('termek-nev-line').text(termek_nev);
            termnev_kont.appendTo(msgwin);
        }

        $('<div>').addClass('video-kont').html(pVideo).appendTo(msgwin);
        msgwin.appendTo($('body'));
    }
}

class termeklistaVideoFelugro {

    constructor() {
        this.observers = [];
    }

    init() {
        if ($('.webshop-termek-list-kont .productlist-kont .webshop-filter-result .item').length > 0) {
            $('.webshop-termek-list-kont .productlist-kont .webshop-filter-result .item').each((i, tItem) => {
                $(tItem).find('.video-popup-link').each((i, vidlink) => {
                    $(vidlink).on('click', (e) => {
                        e.preventDefault();
                        this.showPopUp(
                            $(e.target).attr('href'),
                            $(e.target).parents('.podor-product').data('termek_nev')
                        );
                    });
                });
            });
        }

        if ($('.product-category-list-container .item').length > 0) {
            $('.product-category-list-container .item').each((i, tItem) => {
                $(tItem).find('.video-popup-link').each((i, vidlink) => {
                    $(vidlink).on('click', (e) => {
                        e.preventDefault();
                        this.showPopUp(
                            $(e.target).attr('href'),
                            $(e.target).parents('.podor-product').data('termek_nev')
                        );
                    });
                });
            });
        }

        /*
        var obsTitems = document.querySelectorAll('.webshop-termek-list-kont .productlist-kont .webshop-filter-result .bgimage-kont');
        if (obsTitems.length > 0)
        {
            for (var obsTitemInd = 0; obsTitemInd < obsTitems.length; ++obsTitemInd)
            {
                var obsTitem = obsTitems[obsTitemInd];

                var observerItemLatszik = new IntersectionObserver(function (entries) {
                    if (entries[0].isIntersecting === true) {
                        var item = $(entries[0].target);

                        var imgEl = $('img', item);
                        if (imgEl.length > 0 && imgEl.attr('src') == '')
                        {
                            $.get('/index.php/webshoplist/loadbgimage', {termek_id: imgEl.parents('.podor-product').data('termek_id')}, function (imgElData) {
                                imgEl.attr({
                                    'src': imgElData.src,
                                    'srcset': imgElData.srcset
                                })
                            })
                        }
                    }
                }, { threshold: [0.1] });
                observerItemLatszik.observe(obsTitem);
                this.observers.push(observerItemLatszik);
            }
        }
        */

    }

    showPopUp(vidsource, termek_nev) {
        $('.pms-overlay, .termekadatlap-video-win').remove();

        var msgwin = $('<div>').addClass('termekadatlap-video-win');

        $('<div>').addClass('pms-overlay').on("click", function (e) { e.preventDefault(); $('.pms-overlay, .termekadatlap-video-win').remove(); }).appendTo($('body'));
        $('<a>').addClass('closeme').attr("href", "").on("click", function (e) { e.preventDefault(); $('.pms-overlay, .termekadatlap-video-win').remove(); }).appendTo(msgwin);

        var pVideo = $('<video>').attr('controls', '1');
        pVideo.attr('controlslist', 'nodownload');
        pVideo.attr('autoplay', '1');
        var pSource = $('<source>').attr('type', 'video/mp4');
        pSource.attr('src', vidsource);
        pSource.appendTo(pVideo);

        $('<div>').addClass('video-kont').html(pVideo).appendTo(msgwin);


        if (termek_nev != '') {
            var termnev_kont = $('<div>').addClass('termek-nev-line').text(termek_nev);
            termnev_kont.appendTo(msgwin);
        }

        msgwin.appendTo($('body'));
    }
}


class NewsletterPopup {
    init() {
        // Kizárólag akkor léphet működésbe, ha az URL GET paraméterében ott van a "newsletter"
        if (window.location.search.indexOf('newsletter') === -1) {
            return;
        }

        if ($('#newsletterpopup').length > 0) {
            $('#newsletterpopup').on('click', (e) => {
                e.preventDefault();
                this.triggerPopup('click');
            });
        }

        // Mailchimp hivatkozásból érkező látogató (már feliratkozó)
        try {
            var urlParams = new URLSearchParams(window.location.search);
            var utmSource = (urlParams.get('utm_source') || '').toLowerCase();
            var utmMedium = (urlParams.get('utm_medium') || '').toLowerCase();
            if (urlParams.has('mc_eid') || utmSource.indexOf('mailchimp') !== -1 || utmMedium === 'email') {
                localStorage.setItem('newsletter-subscribed', '1');
                var futureDate = new Date();
                futureDate.setDate(futureDate.getDate() + 60);
                localStorage.setItem('newsletter-popup-accepted', futureDate.toISOString());
                return;
            }
        } catch (e) {}

        // Ha bármelyik űrlapon korábban már feliratkozott
        if (localStorage.getItem('newsletter-subscribed') === '1') {
            return;
        }

        // Korábbi bezárás vizsgálata (tesztelés miatt kikapcsolva)
        /*
        if (localStorage.getItem('newsletter-popup-accepted')) {
            var storedDate = new Date(localStorage.getItem('newsletter-popup-accepted'));
            if (new Date() <= storedDate) {
                return;
            }
        }
        */

        // Kizárt oldalak kliensoldali ellenőrzése (kosár, pénztár, belépés, regisztráció)
        var path = window.location.pathname.toLowerCase();
        var excludedPaths = ['/kosar', '/ujkosar', '/cart', '/checkout', '/penztar', '/einkaufswagen', '/login', '/belepes', '/regisztracio', '/clubcardreg', '/primereg', '/corporatereg', '/sys/'];
        for (var i = 0; i < excludedPaths.length; i++) {
            if (path.indexOf(excludedPaths[i]) !== -1) {
                return;
            }
        }

        // Szerveroldali engedély vizsgálata
        if (!$('body').hasClass('newsletter-popup-enabled')) {
            return;
        }

        // Oldalmegtekintés számláló a munkamenetben
        var pv = parseInt(sessionStorage.getItem('nl_popup_pv') || '0', 10) + 1;
        sessionStorage.setItem('nl_popup_pv', pv);

        this.triggered = false;

        // Trigger 1: A 2. oldalmegtekintéstől (nem az első oldalon azonnal)
        if (pv >= 2) {
            this.pvTimer = setTimeout(() => {
                this.triggerPopup('pageview');
            }, 3000);
        }

        // Trigger 2: 30–40 másodperc után
        this.timeTimer = setTimeout(() => {
            this.triggerPopup('timer');
        }, 35000);

        // Trigger 3: 50%-os görgetésnél
        $(window).on('scroll.nlPopup', () => {
            var scrollPos = $(window).scrollTop() + $(window).height();
            var docHeight = $(document).height();
            if (docHeight > 0 && (scrollPos / docHeight) >= 0.5) {
                this.triggerPopup('scroll');
            }
        });

        // Trigger 4: Asztali gépen kilépési szándéknál (amikor az egér a böngésző teteje felé indul)
        if (window.innerWidth >= 992) {
            $(document).on('mouseleave.nlPopup', (e) => {
                if (e.clientY <= 10) {
                    this.triggerPopup('exit_intent');
                }
            });
        }
    }

    triggerPopup(reason) {
        if (this.triggered) {
            return;
        }
        this.triggered = true;

        clearTimeout(this.pvTimer);
        clearTimeout(this.timeTimer);
        $(window).off('scroll.nlPopup');
        $(document).off('mouseleave.nlPopup');

        // Ha a beúszó épp nyitva van, visszahúzzuk / fül módba állítjuk, hogy a két réteg ne fusson egyszerre
        $('.beuszo-uzenetek-doboz-kont').removeClass('bring-up');
        var abClose = document.querySelector('.ab-close');
        if (abClose) {
            abClose.click();
        }

        // Munkamenet jelző: a hírlevél popup megjelent, a beúszó várjon
        window.newsletterPopupActive = true;
        sessionStorage.setItem('newsletter-popup-active', '1');

        this.showPopUp();
    }

    showPopUp() {
        if (window.location.search.indexOf('newsletter') === -1) {
            return;
        }

        $('.pms-overlay, .newsletter-popup-win, .newletter-popup-win').remove();

        $.get('/index.php/newsletter-popup?newsletter=1&r=' + new Date().getTime(), (html) => {
            if (!html || html.trim() === '') {
                return false;
            }

            $('<div>')
                .addClass('newsletter-popup-layer newletter-popup-layer pms-overlay')
                .on('click', (e) => {
                    e.preventDefault();
                    this.closePopup();
                })
                .appendTo($('body'));

            var msgwin = $('<div>').addClass('newsletter-popup-win newletter-popup-win opened');
            $('<a>')
                .addClass('closeme')
                .attr('href', '#')
                .attr('aria-label', 'Close')
                .on('click', (e) => {
                    e.preventDefault();
                    this.closePopup();
                })
                .appendTo(msgwin);

            $('<div>').addClass('newsletter-popup-content newletter-popup-content').html(html).appendTo(msgwin);
            msgwin.appendTo($('body'));

            $(document).off('keydown.newsletterPopup').on('keydown.newsletterPopup', (e) => {
                if (e.key === 'Escape' || e.keyCode === 27) {
                    this.closePopup();
                }
            });

            this.initEvents(msgwin);
        });
    }

    initEvents(msgwin) {
        var baseForm = msgwin.find('form');
        if (baseForm.length === 0) {
            return;
        }

        var submitBtn = baseForm.find('button[type="button"], button[type="submit"], .bottombutton button, .bottombutton a.btn');
        submitBtn.addClass('has-event');

        var handleNewsletterSubmit = (e) => {
            if (e) {
                e.preventDefault();
            }

            var error = false;
            var emailInput = baseForm.find('input[name="email"]');

            if (emailInput.length > 0) {
                var emailVal = emailInput.val().trim();
                if (emailVal === '' || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(emailVal)) {
                    emailInput.addClass('shake-shake');
                    setTimeout(() => {
                        emailInput.removeClass('shake-shake');
                    }, 1000);
                    error = true;

                    baseForm.find('.error.text-danger').remove();
                    var errorMsg = (typeof lngMessages !== 'undefined' && lngMessages['Email cím nem tűnik érvényesnek'])
                        ? lngMessages['Email cím nem tűnik érvényesnek']
                        : 'Email cím nem tűnik érvényesnek';
                    emailInput.after('<div class="error mt-2 text-danger">' + errorMsg + '</div>');
                    setTimeout(() => {
                        baseForm.find('.error.text-danger').remove();
                    }, 5000);
                }
            }

            if (error) {
                return false;
            }

            submitBtn.prop('disabled', true);
            var actionUrl = baseForm.attr('action') || '/index.php/newsletter-popup/subscribe';
            $.post(actionUrl, baseForm.serialize(), (res) => {
                submitBtn.prop('disabled', false);

                if (res && res.status === 'success') {
                    var successHtml = '<div class="alert alert-success text-center mt-3">' + res.msg + '</div>';
                    baseForm.find('.hirlevel-felugro-uzenet, .alert').remove();
                    baseForm.find('.hirlevel-felugro-input-kont, .hirlevel-felugro-szoveg2, .bottombutton').hide();
                    baseForm.prepend(successHtml);

                    // Feliratkozás elmentése: többé nem jön fel a popup
                    localStorage.setItem('newsletter-subscribed', '1');
                    var futureDate = new Date();
                    futureDate.setDate(futureDate.getDate() + 60);
                    localStorage.setItem('newsletter-popup-accepted', futureDate.toISOString());

                    if (res.redirect) {
                        setTimeout(() => {
                            window.location.href = res.redirect;
                        }, 1200);
                    } else {
                        setTimeout(() => {
                            this.closePopup();
                        }, 3500);
                    }
                } else {
                    var errorMsg = (res && res.msg) ? res.msg : 'Hiba történt a feliratkozás során!';
                    baseForm.find('.hirlevel-felugro-uzenet, .alert-danger').remove();
                    baseForm.find('.hirlevel-felugro-input-kont').before('<div class="alert alert-danger text-center mt-3">' + errorMsg + '</div>');
                }
            }, 'json').fail(() => {
                submitBtn.prop('disabled', false);
                baseForm.find('.hirlevel-felugro-uzenet, .alert-danger').remove();
                baseForm.find('.hirlevel-felugro-input-kont').before('<div class="alert alert-danger text-center mt-3">Hiba történt a kommunikáció során!</div>');
            });
        };

        submitBtn.off('click').on('click', handleNewsletterSubmit);
        baseForm.off('submit').on('submit', handleNewsletterSubmit);
    }

    closePopup() {
        $('.pms-overlay, .newsletter-popup-win, .newletter-popup-win').remove();
        $(document).off('keydown.newsletterPopup');

        // Tesztelés miatt a 30 napos tiltás mentése kikapcsolva
        // var futureDate = new Date();
        // futureDate.setDate(futureDate.getDate() + 30);
        // localStorage.setItem('newsletter-popup-accepted', futureDate.toISOString());
    }
}



class InfluencerRegisztracio {
    init() {
        $('.influencer-reg form').on('submit', (e) => {
            e.preventDefault();
            this.validateForm();

        })
    }

    validateForm() {
        var form = $('.influencer-reg form');

        $.post('/index.php/influencer/frontend-validate', form.serialize(), function (res) {
            if (res.errors && Object.keys(res.errors).length > 0) {
                $.each(res.errors, function (field, error) {
                    var fieldEl = form.find('[name="' + field + '"]');

                    // ha a fieldel checkbox, akkor a parent().parent()-hez adja hozzá, egyébként csak a parent()-hez
                    if (fieldEl.attr('type') == 'checkbox') {
                        var errorEl = fieldEl.parent().parent().find('.error');
                        if (errorEl.length == 0) {
                            errorEl = $('<div>').addClass('error floated').appendTo(fieldEl.parent().parent());
                        }
                    } else {
                        var errorEl = fieldEl.parent().find('.error');
                        if (errorEl.length == 0) {
                            errorEl = $('<div>').addClass('error').appendTo(fieldEl.parent());
                        }
                    }
                    errorEl.text(error);
                })

                $.each(res.errors, function (field, error) {
                    if (field == 'email_exists_user') {
                        form.find('.error').text('');
                        form.find('.exist-user-forcelogin').removeClass('d-none');
                        form.find('.disable-if-exists input').each(function (i, el) {
                            $(el).prop('disabled', true).css('opacity', 0.3);
                        })
                    }
                });

                setTimeout(function () {
                    form.find('.error').text('');
                }, 5000);
            } else {
                form.off('submit').submit();
            }
        }, 'json');

    }

}

export {
    beuszoControl,
    sargaCsikControl,
    popupSzettLista,
    termekAdatlapVideo,
    termeklistaVideoFelugro,
    NewsletterPopup,
    InfluencerRegisztracio
};
